import React, { Fragment, useCallback, useEffect, useState } from 'react'
import MonCompteHeader from '../MonCompteHeader'
import { Collapse, IconButton, List, ListItemButton, ListItemText, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import './VosCommandes.css';
import { Demande, Programmation, StyleMusique } from '../../../../Models/Demande/DemandeModels';
import { useCookies } from 'react-cookie';
import { DemandeService } from '../../../../Services/Demande/DemandeService';
import { CategorieMessage, Flux } from '../../../../Models/Message/MessageModels';
import { FluxService } from '../../../../Services/Message/FluxService';
import DownloadIcon from '@mui/icons-material/Download';
import dayjs from 'dayjs';
import { StyleMusiqueService } from '../../../../Services/Styles/StyleMusiqueService';
import { Berceau } from '../../../../Models/Marketing/BerceauModel';
import { BerceauService } from '../../../../Services/Marketing/BerceauSpotExpress';
import { CategorieMessageService } from '../../../../Services/Message/CategorieMessageService';
import SearchIcon from '@mui/icons-material/Search';
import DialogMessagesCommandesCampagne from './DialogMessagesCommandesCampagne';
import { URL_DOWNLOAD } from '../../../../Setting';


export function VosCommandes(props: {
  setInterfaceMonCompte: any
  interfaceMonCompte: number
}) {

  const optionsCommandes = [
    {id:0, label:"Mes Campagnes Galec", type:'galec'},
    {id:1, label:"Mes spots express", type:'spotExpress'},
    {id:2, label:"Mes Catalogues Midiscom", type:'cataMidis'},
    {id:3, label:"Mes spots à intégrer", type:'spotIntegrer'},
    {id:4, label:"Mes musiques thématiques / Soirées", type:'musiqueThematique'},
  ];
  const [demandes, setDemandes] = useState<Demande[]>([]);
  const [fluxes, setFluxes] = useState<Flux[]>([]);
  const[loading,setLoading]=useState(true);
  const [musiquesThematiques, setMusiquesThematiques] = useState<StyleMusique[]>([]);
  const [programmationsSoiree, setProgrammationsSoiree] = useState<Programmation[]>([]);
  const [berceaux, setBerceaux] = useState<Berceau[]>([]);
  const [cataloguesGalec, setCataloguesGalec] = useState<CategorieMessage[]>([]);
  const [cataloguesMidis, setCataloguesMidis] = useState<CategorieMessage[]>([]);
  const regexIntrodcution = new RegExp(`\\b${'introduction'}\\b`, 'i'); // Recherche le terme en entier, insensible à la casse
  const regexSignature = new RegExp(`\\b${'signature'}\\b`, 'i'); // Recherche le terme en entier, insensible à la casse
  const berceauIntro = berceaux.filter(berceau=>regexIntrodcution.test(berceau.type));
  const berceauSignature = berceaux.filter(berceau=>regexSignature.test(berceau.type));

  //Services
  const[cookies] = useCookies(['token']);
  const token = cookies.token;

  //gestion nested list
  interface InitialStateI {
    [key: number]: boolean;
  }
  const [selectedOption, setSelectedIndex] = useState<number>();
  const optionState:InitialStateI = Object.fromEntries(optionsCommandes.map((value)=>([value.id, false])));
  const [openOption, setOpenOption] = useState(optionState);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
    setOpenOption((o)=>({ ...optionState, [index]: !o[index] }));
  };

  //Automatisation récupération des données
  const infosCommandes = useCallback(async ()=>{
    if(token){
      // await DemandeService().deleteDemande(102635,token)
      const result = await DemandeService().getDemandes(token);
      const fluxesResult = await FluxService().getFluxesLight(token); //peut utiliser ouletcontext pour recup flux mais change pas grand cose ce qui ralentit le plus ce sont les demandes
      const cataloguesGalec = await CategorieMessageService().getCategoriesMessagesCatalogueGALECAdmin(token);
      setCataloguesGalec(cataloguesGalec);
      const CataloguesMidis = await CategorieMessageService().getCategoriesMessagesCatalogueMIDISAdmin(token);
      setCataloguesMidis(CataloguesMidis);
      const berceauxResult = await BerceauService().getBerceaux(token);
      setBerceaux(berceauxResult);
      const stylesThematiquesResult = await StyleMusiqueService().getStylesMusiquesThematiqueUser(token);
      setMusiquesThematiques(stylesThematiquesResult);
      const programmationsResult = await StyleMusiqueService().getProgrammationsSoiree(token);
      setProgrammationsSoiree(programmationsResult);
      setDemandes(result);
      setFluxes(fluxesResult);
      setLoading(false)
    }
  },[token])
  
  useEffect(()=>{
    if(loading)
      infosCommandes();
  },[infosCommandes, loading]);

  //méthodes
  // function supprimerExtension(nomFichier: string): string {
  //   const indexDernierPoint = nomFichier.lastIndexOf('.');
  //   if (indexDernierPoint === -1) {
  //     // Pas d'extension trouvée
  //     return nomFichier;
  //   }
  //   return nomFichier.substring(0, indexDernierPoint);
  // }

  // function supprimerUpload(nomFichier: string): string {
  //   const indexDernierSlash = nomFichier.lastIndexOf('/');
  //   if (indexDernierSlash === -1) {
  //       // Pas d'extension trouvée
  //       return nomFichier;
  //   }
  //   return nomFichier.substring(indexDernierSlash+1, nomFichier.length);
  // }

  // const telechargerFichierSpotIntegrer = (chemin:string, nomFichier:string)=>{
  //   // if(!nomFichier)return;
  //   const fichierAvecExtension = supprimerUpload(chemin);
  //   return URL_DOWNLOAD+fichierAvecExtension;
  //   // const nouveauNom = supprimerExtension(nomFichier);
  //   // await FichierService().downloadFichierViaChemin(chemin, nouveauNom, token);
  // }

  // const telechargerFichierSpotIntegrer = async (chemin:string, nomFichier:string)=>{
  //   if(!nomFichier)return;
  //   const nouveauNom = supprimerExtension(nomFichier);
  //   await FichierService().downloadFichierViaChemin(chemin, nouveauNom, token);
  // }

  //gestion dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [codeCampagneDialog, setCodeCampagneDialog] = useState('');
  const [nomCampagneDialog, setNomCampagneDialog] = useState('');
  const [demandesDialog, setDemandesDialog] = useState<Demande[]>([]);
  const checkMessages = (code:string, nom:string, demandes:Demande[])=>{
    setCodeCampagneDialog(code);
    setNomCampagneDialog(nom)
    setDemandesDialog(demandes);
    setOpenDialog(true);
  }

  const affichageListeDemande = (typeCommande:string, demandes:Demande[])=>{
    let demandesFiltres:Demande[]=[];
    let demandesSorted:Demande[]=[];
    let demandes1erFiltrage:Demande[]=[];
    let demandes2ndFiltrage:Demande[]=[];
    let campagneGalecFiltres:CategorieMessage[]=[];
    let campagneMidisFiltres:CategorieMessage[]=[];
    let tableBody = (<></>);

    switch(typeCommande){
      case 'galec':
        demandesFiltres = demandes.filter(demande=>demande.parametresCampagnes
            && demande.parametresCampagnes.typeCampagne.toLowerCase()==='galec'
            && demande.typeDemande.type==='Campagne'
            && demande.parametresCampagnes.diffusion!=='non');

        campagneGalecFiltres = cataloguesGalec.filter(cat=>demandesFiltres.find(dem=>dem.parametresCampagnes && dem.parametresCampagnes.campagne===cat.code)).sort((a, b)=>new Date(b.fin).getTime() - new Date(a.fin).getTime());
        demandesSorted = demandesFiltres.sort((a, b)=>new Date(b.dateApplication).getTime() - new Date(a.dateApplication).getTime()) //Filtrage par date demande
        tableBody = (
          <TableContainer sx={{maxHeight:300}}>
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Code Campagne</TableCell>
                  <TableCell>Campagne</TableCell>
                  <TableCell>Début</TableCell>
                  <TableCell>Fin</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              {
                campagneGalecFiltres.map((cat, index)=>(
                  <TableBody key={index}>
                    <TableCell>{cat.code}</TableCell>
                    <TableCell>{cat.nom}</TableCell>
                    <TableCell>{dayjs(cat.debut).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{dayjs(cat.fin).format('DD/MM/YYYY')}</TableCell>
                    <TableCell><IconButton onClick={()=>{checkMessages(cat.code, cat.nom, demandesSorted)}}><SearchIcon/></IconButton></TableCell>
                  </TableBody>
                ))
              }
            </Table>
          </TableContainer>
        );
        break;
      case 'spotIntegrer':
        demandesFiltres = demandes.filter(demande=>demande.parametresDuplications && demande.typeDemande.type==='Duplication');
        // demandes1erFiltrage = demandesFiltres.filter(dem=>dem.parametresDuplications && dayjs(dem.parametresDuplications.dateFin).isAfter(dayjs(dem.dateApplication)))
        // diffusion pour les demandes recentes, convention des dates pour les anciennes
        demandes1erFiltrage = demandesFiltres.filter(dem=>{
            if(!dem.parametresDuplications)return false;
            if(dem.parametresDuplications.diffusion)return dem.parametresDuplications.diffusion!=='non';
            return dayjs(dem.parametresDuplications.dateFin).isAfter(dayjs(dem.dateApplication));
        });
        demandes2ndFiltrage = demandes1erFiltrage.filter(demande=> !demandes1erFiltrage.find(dem=> dem.id!==demande.id && demande.parametresDuplications && dem.parametresDuplications 
          && dem.parametresDuplications.titre===demande.parametresDuplications.titre 
          && dem.parametresDuplications.fichier===demande.parametresDuplications.fichier
          && dayjs(dem.dateDemande).isAfter(demande.dateDemande)
        )); //filtre pour n'avoir que la première commande parmi les demandes d'activation
        demandesSorted = demandes2ndFiltrage.sort((a, b)=>new Date(b.parametresDuplications?.dateDebut ?? b.dateApplication).getTime() - new Date(a.parametresDuplications?.dateDebut ?? a.dateApplication).getTime()) //Filtrage par date demande
        tableBody = (
          <TableContainer sx={{maxHeight:300}}>
            <Table stickyHeader size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Titre</TableCell>
                <TableCell>Début</TableCell>
                <TableCell>Fin</TableCell>
                <TableCell>Fichier</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
              {
                demandesSorted.map((demande, index)=>(
                  <TableBody key={index}>
                    <TableCell>{demande.parametresDuplications?.titre}</TableCell>
                    <TableCell>{dayjs(demande.parametresDuplications?.dateDebut).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{dayjs(demande.parametresDuplications?.dateFin).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{demande.parametresDuplications?.fichier ?? "Aucun fichier"}</TableCell>
                    <TableCell>
                      <Tooltip title='Télécharger'>
                        {/* <IconButton size='small' href={telechargerFichierSpotIntegrer(demande.fichiers[0].chemin, '')} download="fichier" target='_blank'><DownloadIcon/></IconButton>   */}
                        <IconButton size='small' disabled={demande.fichiers.length===0} href={ demande.fichiers.length>0 ? URL_DOWNLOAD+demande.fichiers[0].chemin : ''} download target='_blank'><DownloadIcon/></IconButton> 
                      </Tooltip>
                    </TableCell>
                  </TableBody>
                ))
              }
            </Table>
          </TableContainer>
        );
        break;
      case 'spotExpress':
        demandesFiltres = demandes.filter(demande=>demande.parametresSpotExpress && demande.typeDemande.type==='Spot');
        // demandes1erFiltrage = demandesFiltres.filter(dem=>dem.parametresSpotExpress && dayjs(dem.parametresSpotExpress.dateFin).isAfter(dayjs(dem.dateApplication))); //filtre les demandes de désac avec les demande d'activation
        // diffusion pour les demandes recentes, convention des dates pour les anciennes
        demandes1erFiltrage = demandesFiltres.filter(dem=>{
            if(!dem.parametresSpotExpress)return false;
            if(dem.parametresSpotExpress.diffusion)return dem.parametresSpotExpress.diffusion!=='non';
            return dayjs(dem.parametresSpotExpress.dateFin).isAfter(dayjs(dem.dateApplication));
        });
        demandes2ndFiltrage = demandes1erFiltrage.filter(demande=> !demandes1erFiltrage.find(dem=> dem.id!==demande.id && demande.parametresSpotExpress && dem.parametresSpotExpress 
          && dem.fluxes.find(fluxDem=>demande.fluxes.find(flux=>flux.id===fluxDem.id))
          && dem.parametresSpotExpress.titre===demande.parametresSpotExpress.titre
          && dem.parametresSpotExpress.message===demande.parametresSpotExpress.message
          && dayjs(dem.dateDemande).isAfter(demande.dateDemande)
        )); //filtre pour n'avoir que la première commande parmi les demandes d'activation
        demandesSorted = demandes2ndFiltrage.sort((a, b)=>new Date(b.parametresSpotExpress?.dateDebut ?? b.dateApplication).getTime() - new Date(a.parametresSpotExpress?.dateDebut ?? a.dateApplication).getTime()) //Filtrage par date demande
        tableBody = (
          <TableContainer sx={{maxHeight:300}}>
            <Table stickyHeader size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Intitule</TableCell>
                <TableCell>Type de voix</TableCell>
                <TableCell>Introduction</TableCell>
                <TableCell>Texte</TableCell>
                <TableCell>Signature</TableCell>
                <TableCell>Début</TableCell>
                <TableCell>Fin</TableCell>
                <TableCell>Flux concerné(s)</TableCell>
              </TableRow>
            </TableHead>
              {
                demandesSorted.map((demande, index)=>(
                  <TableRow key={index}>
                    <TableCell>{demande.parametresSpotExpress?.titre}</TableCell>
                    <TableCell>{demande.parametresSpotExpress?.typeVoix}</TableCell>
                    <TableCell>{berceauIntro.find(berc=>{if(demande.parametresSpotExpress && berc.id===demande.parametresSpotExpress.idBerceauIntro)return berc; return undefined})?.description}</TableCell>
                    <TableCell>{demande.parametresSpotExpress?.message}</TableCell>
                    <TableCell>{berceauSignature.find(berc=>{if(demande.parametresSpotExpress && berc.id===demande.parametresSpotExpress.idBerceauSignature)return berc; return undefined})?.description}</TableCell>
                    <TableCell>{dayjs(demande.parametresSpotExpress?.dateDebut).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>{dayjs(demande.parametresSpotExpress?.dateFin).format('DD/MM/YYYY')}</TableCell>
                    <TableCell>
                      {demande.fluxes.map(fluxDemande=>{
                        let flux = fluxes.find(flux=>flux['@id']===fluxDemande['@id']);
                        if(flux)return flux.nom+", "
                        return fluxDemande.nom
                      })}
                    </TableCell>
                  </TableRow>
                ))
              }
            </Table>
          </TableContainer>
        );
        break;
      case 'cataMidis':
        demandesFiltres = demandes.filter(demande=>demande.parametresCampagnes
            && demande.parametresCampagnes.typeCampagne.toLowerCase()==='cata midis'
            && demande.typeDemande.type==='Campagne'
            && demande.parametresCampagnes.diffusion!=='non');

        campagneMidisFiltres = cataloguesMidis.filter(cat=>demandesFiltres.find(dem=>dem.parametresCampagnes && dem.parametresCampagnes.campagne===cat.code));
        demandesSorted = demandesFiltres.sort((a, b)=>new Date(b.parametresCampagnes?.dateDebut ?? b.dateApplication).getTime() - new Date(a.parametresCampagnes?.dateDebut ?? a.dateApplication).getTime()) //Filtrage par date demande
        tableBody = (
          <TableContainer sx={{maxHeight:300}}>
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Code Campagne</TableCell>
                  <TableCell>Campagne</TableCell>
                  <TableCell>Début</TableCell>
                  <TableCell>Fin</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              {
                campagneMidisFiltres.map((cat, index)=>(
                  <TableBody key={index}>
                    <TableRow>
                      <TableCell>{cat.code}</TableCell>
                      <TableCell>{cat.nom}</TableCell>
                      <TableCell>{dayjs(cat.debut).format('DD/MM/YYYY')}</TableCell>
                      <TableCell>{dayjs(cat.fin).format('DD/MM/YYYY')}</TableCell>
                      <TableCell><IconButton onClick={()=>{checkMessages(cat.code, cat.nom, demandesFiltres)}}><SearchIcon/></IconButton></TableCell>
                    </TableRow>
                  </TableBody>
                ))
              }
            </Table>
          </TableContainer>
        );
        break;
      case 'musiqueThematique':
        demandesFiltres = demandes.filter(demande=>(demande.parametresMusiquesThematiques || demande.parametresSoirees) && (demande.typeDemande.type==='Soirées' || demande.typeDemande.type==='Thematique'));
        demandes1erFiltrage = demandesFiltres.filter(dem=>{
          if(dem.parametresMusiquesThematiques){
            return dem.parametresMusiquesThematiques && dem.parametresMusiquesThematiques.diffusion==="oui";
          }
          if(dem.parametresSoirees){
            return dem.parametresSoirees && dem.parametresSoirees.diffusion==="oui"
          }
          return false;
        })
        demandesSorted = demandes1erFiltrage.sort((a, b)=>new Date(b.dateApplication).getTime() - new Date(a.dateApplication).getTime()) //Filtrage par date demande
        tableBody = (
          <TableContainer sx={{maxHeight:400}}>
            <Table stickyHeader size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Type</TableCell>
                  <TableCell>Musique</TableCell>
                  <TableCell>Début</TableCell>
                  <TableCell>Fin</TableCell>
                  <TableCell>Diffusion pour le personnel</TableCell>
                  <TableCell>Fréquence</TableCell>
                  <TableCell>Flux</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  demandesSorted.map((demande,index)=>(
                    <>
                      {
                        <TableRow key={index}>
                          <TableCell>{demande.typeDemande.type}</TableCell>
                          <TableCell>{demande.typeDemande.id===7 ? musiquesThematiques.find(style=>style.id===demande.parametresMusiquesThematiques?.idStyle)?.nom : programmationsSoiree.find(prog=>prog.id===demande.parametresSoirees?.idProgrammation)?.nom}</TableCell>
                          <TableCell>
                            {demande.typeDemande.id===7 ? dayjs(demande.parametresMusiquesThematiques?.debut).format('DD/MM/YYYY') : dayjs(demande.parametresSoirees?.date).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell>
                            {demande.typeDemande.id===7 ? dayjs(demande.parametresMusiquesThematiques?.fin).format('DD/MM/YYYY') : dayjs(demande.parametresSoirees?.date).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell>
                            {demande.typeDemande.id===7 ? demande.parametresMusiquesThematiques?.diffusionPersonnel ? 'Oui' : 'Non' : 'Non'}
                          </TableCell>
                          <TableCell>{demande.typeDemande.id===7 ? demande.parametresMusiquesThematiques?.ratio : 'Aucune'}</TableCell>
                          <TableCell>
                            {demande.fluxes.map(fluxDemande=>{
                              let flux = fluxes.find(flux=>flux['@id']===fluxDemande['@id']);
                              if(flux)return flux.nom+', '
                              return fluxDemande.nom+', '
                            })}
                          </TableCell>
                        </TableRow>
                      }
                    </>
                  ))
                }
              </TableBody>
            </Table>
          </TableContainer>
        );
        break;
      default:
        break;
    }

    return(
      <List>
        {tableBody}
      </List>
    )

  }

  return (
    <div className='MonCompte-selected-part'>
      <MonCompteHeader
        setInterfaceMonCompte={props.setInterfaceMonCompte}
        interfaceMonCompte={props.interfaceMonCompte}
        mainText='Vos commandes'
        subText='Consulter vos commandes en cours et vos commandes terminées'
      />
      <div className="VosCommandes-mainBody">
        <div className='VosCommandes-body'>
          {
            !loading ?
            <List sx={{ width: '90%' }}>
              {
                optionsCommandes.map((optionCommande, index)=>(
                  <Fragment key={index}>
                    <ListItemButton 
                        alignItems="flex-start" 
                        onClick={()=>{handleClick(optionCommande.id)}}
                        selected={selectedOption===optionCommande.id}
                      >
                        <ListItemText
                          primary={optionCommande.label}
                        >
                        </ListItemText>
                        {openOption[optionCommande.id] ? <ExpandLess /> : <ExpandMore />}
                      </ListItemButton>
                      <Collapse in={openOption[optionCommande.id]} timeout="auto" unmountOnExit>
                          {affichageListeDemande(optionCommande.type, demandes)}
                      </Collapse>
                      {/* <Divider component="li" variant="middle"/> */}
                  </Fragment>
                ))
              }
            </List>
            :
            <div style={{display:'flex', flexDirection:'column', width:'90%', height:'90%'}}>
              <Skeleton sx={{m:1}}/>
              <Skeleton sx={{m:1}}/>
              <Skeleton sx={{m:1}}/>
              <Skeleton sx={{m:1}}/>
            </div>
          }
          <DialogMessagesCommandesCampagne
            open={openDialog}
            onClose={()=>{setOpenDialog(false)}}
            codeCampagneDialog={codeCampagneDialog}
            nomCampagneDialog={nomCampagneDialog}
            demandesDialog={demandesDialog}
            fluxes={fluxes}
          />
        </div>
      </div>
    </div>
  )
}
